var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotificationIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 13,
  fill: "none",
  viewBox: "0 0 12 13"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11.862 9.496c-.347-.597-.863-2.288-.863-4.496A5 5 0 0 0 1 5C1 7.209.483 8.899.136 9.496A1 1 0 0 0 1 11h2.55a2.5 2.5 0 0 0 4.9 0h2.55a1 1 0 0 0 .863-1.504M5.999 12a1.5 1.5 0 0 1-1.413-1h2.827a1.5 1.5 0 0 1-1.414 1m-5-2c.482-.828 1-2.745 1-5a4 4 0 1 1 8 0c0 2.253.518 4.17 1 5z"
})));
export { SvgNotificationIcon as ReactComponent };
export default __webpack_public_path__ + "e36f25e48f49d42f2e6761f84ca100db.svg";